import { render, staticRenderFns } from "./OtherShippersModule.vue?vue&type=template&id=62ede1c3"
import script from "./OtherShippersModule.vue?vue&type=script&lang=js"
export * from "./OtherShippersModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports